/**
 * This is a temporary component that mirrors the implementation from
 * https://github.com/ConvertKit/convertkit/pull/19858 to allow users to add
 * additional layout blocks between each other.
 *
 * When the new block toolbar design goes live, this file and layout.scss can be
 * deleted, and <WrapperBlockToolbar> can be removed from layout.js.
 */

import React from "react"
import { useBlocks } from "app/regions/hooks/use-blocks"
import { useEditing } from "app/regions/hooks/use-editing"
import Icon from "@kit/design/icon"
import { VisuallyHidden } from "@kit/design/visually-hidden"

function BlockToolbarButton({ block, position }) {
  const { add } = useBlocks(block.parent_id)

  function addLayout(e) {
    e.stopPropagation()
    add({ type: "layout" }, { position })
  }

  return (
    <div className="absolute left-0 right-0 text-center z-10 -mt-3">
      <button
        className="ck-wrapper-block-toolbar-button text-white m-auto w-6 h-6 flex items-center justify-center rounded opacity-0 group-hover:opacity-100 transition-opacity duration-100"
        onClick={addLayout}
      >
        <Icon name="plus" />
        <VisuallyHidden>Add layout</VisuallyHidden>
      </button>
    </div>
  )
}

export function WrapperBlockToolbar({ block, children }) {
  const editing = useEditing()

  if (!editing) return children

  return (
    <div className="ck-wrapper-block-toolbar group">
      <BlockToolbarButton block={block} position={block.order} />
      {children}
      <BlockToolbarButton block={block} position={block.order + 1} />
    </div>
  )
}
